import React from 'react';
import Icon from './AppIcon';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const navigationLinks = [
    { label: 'الرئيسية', path: '/' },
    { label: 'السلة', path: '/cart' },
    { label: 'طلباتى', path: '/orders' },
    { label: 'المفضلة', path: '/favorites' },
    { label: 'الحساب', path: '/account' }
  ];

  const socialMedia = [
    { name: 'Facebook', icon: 'Facebook', url: '#' },
    { name: 'Twitter', icon: 'Twitter', url: '#' },
    { name: 'Instagram', icon: 'Instagram', url: '#' },
    { name: 'MessageCircle', icon: 'MessageCircle', url: '#' }
  ];

  return (
    <footer className="bg-white border-t mt-2 font-[cairo]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8" dir="rtl">
          {/* Company/Brand Section */}


          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                <img src='/assets/images/logo.jpeg' />
              </div>
              <span className="text-xl font-bold text-foreground">يسلمو</span>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed">
              تطبيق توصيل ذكى يمكنك من تصفح المطاعم والماركتات وطلب الطعام والمستلزمات من أماكن متعددة فى سلة واحدة
            </p>
          </div>

          {/* Quick Links Section */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground font-[cairo]">روابط سريعة</h3>
            <ul className="space-y-1">
              {navigationLinks?.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => navigate(link?.path)}
                    className="text-muted-foreground hover:text-primary transition-colors duration-200 text-sm"
                  >
                    {link?.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Information Section */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground font-[cairo]">تواصل معنا</h3>
            <ul className="space-y-1">
              <li
                className="flex items-center gap-2 text-muted-foreground text-sm cursor-pointer"
                onClick={() => {
                  window.open("https://wa.me/963996154965", "_blank");
                }}
              >
                <Icon name="Phone" size={16} color="var(--color-primary)" />
                <span dir="ltr">+963 99615 4965</span>
              </li>
              <li
                className="flex items-center gap-2 text-muted-foreground text-sm cursor-pointer"
                onClick={() => {
                  window.location.href = "mailto:info@yslamo.com";
                }}
              >
                <Icon name="Mail" size={16} color="var(--color-primary)" />
                <span dir="ltr">info@yslamo.com</span>
              </li>
              
            </ul>
          </div>

          {/* Social Media Section */}
          {/* <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground font-[cairo]">تابعنا</h3>
            <div className="flex gap-3">
              {socialMedia?.map((social, index) => (
                <a
                  key={index}
                  href={social?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-muted hover:bg-primary hover:text-white transition-all duration-200 flex items-center justify-center group"
                  aria-label={social?.name}
                >
                  <Icon 
                    name={social?.icon} 
                    size={18} 
                    color="currentColor"
                  />
                </a>
              ))}
            </div>
            <p className="text-muted-foreground text-sm mt-4">
              تابعنا على وسائل التواصل الاجتماعي للحصول على أحدث العروض والتحديثات
            </p>
          </div> */}
        </div>

        {/* Divider */}
        <div className="border-t border-border my-8"></div>

        {/* Copyright Section */}
        <div className="text-center" dir="rtl">
          <p className="text-muted-foreground text-sm">
            © 2026 جميع الحقوق محفوظة - Salezeus Team
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;